import whenDomReady from 'when-dom-ready';
function initialise() {
    const header = document.querySelector('.js-header');
    const nav = document.querySelector('.js-nav');
    if (!header && !nav) {
        return;
    }
    const burger = document.querySelector('.js-burger');
    const triggers = document.querySelectorAll('.js-nav .js-has-dropdown');
    const background = document.querySelector('.js-dropdown-bg');
    const body = document.querySelector('.js-body');
    const subnav = document.querySelector('.js-subnav-wrapper');
    stickyHeader();
    // Setup a resize observer to track changes.
    window.addEventListener('resize', stickyHeader);
    window.addEventListener('scroll', stickyHeader);
    function handleEnter(event) {
        if (event.target instanceof Element) {
            event.target.classList.add('trigger-enter');
            setTimeout(() => {
                if (event.target instanceof Element) {
                    event.target.classList.contains('trigger-enter');
                }
            });
            background.classList.add('is-open');
            const dropdown = event.target.querySelector('.js-dropdown');
            if (dropdown) {
                const dropdownCoords = dropdown.getBoundingClientRect();
                const navCoords = nav.getBoundingClientRect();
                const coords = {
                    height: dropdownCoords.height,
                    width: dropdownCoords.width,
                    top: dropdownCoords.top - navCoords.top,
                    left: dropdownCoords.left - navCoords.left,
                };
                background.style.setProperty('width', `${coords.width}px`);
                background.style.setProperty('height', `${coords.height}px`);
                background.style.setProperty('transform', `translate(${coords.left}px, ${coords.top}px)`);
            }
        }
    }
    function handleLeave(event) {
        if (event.target instanceof Element) {
            event.target.classList.remove('trigger-enter');
        }
        background.classList.remove('is-open');
    }
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < triggers.length; i++) {
        // The "trigger" here is an <li /> we should be handling clicking on the anchor.
        const navItem = triggers[i];
        if ('touchstart' in window) {
            navItem.addEventListener('touchstart', handleEnter);
        }
        else {
            navItem.addEventListener('mouseenter', handleEnter);
        }
        if ('touchmove' in window) {
            navItem.addEventListener('touchmove', handleLeave);
        }
        else {
            navItem.addEventListener('mouseleave', handleLeave);
        }
        // Get anchor link.
        const navLink = navItem.firstElementChild;
        navLink.addEventListener('click', (e) => {
            const targetElement = e.target;
            const isDesktop = window.matchMedia('(min-width: 1190px)').matches;
            // Check if we've clicked on the icon, if so then don't navigate.
            if ((targetElement.matches('.js-nav-link-dropdown') ||
                targetElement.matches('svg') ||
                targetElement.matches('use')) &&
                !isDesktop) {
                e.preventDefault();
                navLink.classList.toggle('is-open');
            }
        });
    }
    const ACTIVE = 'is-active';
    const READY = 'is-ready';
    if ('ontouchstart' in window) {
        burger.addEventListener('touchstart', () => {
            burgerClick();
        });
    }
    else {
        burger.addEventListener('click', () => {
            burgerClick();
        });
    }
    function burgerClick() {
        nav.classList.toggle(ACTIVE);
        burger.classList.add(READY);
        body.classList.toggle(ACTIVE);
        if (burger.classList.contains(ACTIVE)) {
            setTimeout(() => {
                burger.classList.remove(ACTIVE);
            }, 250);
        }
        else {
            burger.classList.add(ACTIVE);
        }
    }
    function stickyHeader() {
        if (window.scrollY > 20) {
            if (subnav != null) {
                subnav.classList.add('scrolled');
            }
            else {
                header.classList.add('scrolled');
            }
        }
        else {
            if (subnav != null) {
                subnav.classList.remove('scrolled');
            }
            else {
                header.classList.remove('scrolled');
            }
        }
    }
}
whenDomReady().then(initialise);
